import {AttachmentAssetLoader} from './attachment-asset-loader';

class AttachmentAssetService {
  private player: KalturaPlayerTypes.Player;
  private logger: KalturaPlayerTypes.Logger;
  private delayHandler: ReturnType<typeof setTimeout> | null = null;

  constructor(player: KalturaPlayerTypes.Player, logger: KalturaPlayerTypes.Logger) {
    this.player = player;
    this.logger = logger;
  }

  public async fetchVttFile(entryId: string): Promise<string | null> {
    const ks = this.player.config?.session?.ks;
    const responsesMap = await this.player.provider.doRequest([{loader: AttachmentAssetLoader, params: {entryId, tags: 'AAD'}}], ks);

    const attachmentAssetUrlResponse = responsesMap.get(AttachmentAssetLoader.id);

    if (!attachmentAssetUrlResponse || !attachmentAssetUrlResponse.url) {
      throw new Error('attachmentAssetUrl not found');
    }

    const response = await this.fetchWithRetries(attachmentAssetUrlResponse.url);

    // convert file-blob to text.
    if (response.body instanceof ReadableStream) {
      return await new Response(response.body).text();
    } else {
      throw new Error('cannot convert AAD attachmentAsset to text');
    }
  }

  private async fetchWithRetries(url: string, options: any = {}, retries: number = 3, delay: number = 1000) {
    const doFetch: any = async (retryCount: number) => {
      try {
        const response = await fetch(url, options);
        if (response.ok) {
          return response;
        } else {
          if (retryCount < retries) {
            await new Promise(resolve => {
              this.delayHandler = setTimeout(resolve, delay);
            }); // wait for delay
            return doFetch(retryCount + 1);
          } else {
            throw response;
          }
        }
      } catch (error) {
        if (retryCount < retries) {
          await new Promise(resolve => {
            this.delayHandler = setTimeout(resolve, delay);
          }); // wait for delay
          return doFetch(retryCount + 1);
        } else {
          throw error;
        }
      }
    };

    return doFetch(0);
  }

  public destroy() {
    if (this.delayHandler) {
      clearTimeout(this.delayHandler);
      this.delayHandler = null;
    }
  }
}

export {AttachmentAssetService};
